import LazoTooltip from "@/components/utils/LazoTooltip";
import { Colors } from "@/enums/Colors";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { LazoChatConversation } from "@/models/ai-chat/LazoChatConversation";
import { LazoChatMessage } from "@/models/ai-chat/LazoChatMessage";
import { LazoUser } from "@/models/LazoUser";
import { EditNoteOutlined } from "@mui/icons-material";
import { Box, Button, styled, Typography } from "@mui/material";
import MailSVG from "../../../../assets/images/mail-icon.svg";
import AddInvestorToFunderListModal from "../AddInvestorToFunderListModal";

interface ChatMessageContainerProps {
  lazoUser: LazoUser;
  animateTyping?: boolean;
  messageReceiverIsBot?: boolean;
  onTypingFinish?: () => void;
  children: JSX.Element | JSX.Element[];
}

export type ChatMessageProps = {
  lazoUser: LazoUser;
  messageSender?: User;
  dateGroup?: string;
};

const MessageContainer = styled(Box)(({}) => ({
  display: "flex",
  flexDirection: "column",
  paddingTop: "0.5rem",
  minHeight: "20px",
  paddingRight: "1rem",

  "& .vc-label": {
    fontWeight: "bold",
  },

  "& .vc-content": {
    color: "#4b4343",
  },
}));

const StyledButton = styled(Button)(({}) => ({
  maxHeight: "1.75rem",
  display: "inline-flex",
  alignItems: "center",
  padding: "0.5rem",
  marginRight: "0.5rem",
  width: "fit-content",
  backgroundColor: Colors.BUTTON_GRAY,
  color: Colors.ELEGANT_BLACK,
  borderRadius: "0.5rem",
  textTransform: "none",
  ":hover": {
    backgroundColor: Colors.BUTTON_SECONDARY_HOVER_PURPLE,
  },
  "& .MuiTypography-root": {
    fontWeight: "500",
  },
}));

function ChatMessageContainer({ children, messageSender }: ChatMessageContainerProps & ChatMessageProps) {
  // if (animateTyping && message.includes("<li>")) {
  //   onTypingFinish?.();
  // }

  const isNotCurrentUser = messageSender?.externalId !== AuthService.getUser()?.externalId;

  return (
    <MessageContainer>
      <Box
        sx={{
          display: "flex",
          justifyContent: !isNotCurrentUser ? "end" : "start",
          paddingLeft: !isNotCurrentUser ? "1rem" : 0,
        }}
      >
        <Typography
          sx={{
            display: "inline-block",
            width: isNotCurrentUser ? "100%" : "max-content",
            maxWidth: "100%",
            padding: "0rem 0.875rem",
            wordBreak: "break-word",
            borderRadius: !isNotCurrentUser ? "1rem 1rem 0 1rem" : "1rem",
            whiteSpace: "normal",
            textAlign: "start",
            fontWeight: "500",
            backgroundColor: isNotCurrentUser ? Colors.ALMOST_WHITE : Colors.LAZO_PURPLE,
            color: isNotCurrentUser ? Colors.BLACK : Colors.WHITE,
          }}
        >
          {children}
        </Typography>
      </Box>
    </MessageContainer>
  );
}

type BotMessageButtonsProps = {
  lazoChatConversation: LazoChatConversation;
  isExportable?: boolean;
  explainClick: () => void;
  writeApproachEmailClick?: () => void;
  writeFollowUpEmailClick?: () => void;
  messageEntity?: LazoChatMessage;
  openAddToFunderListModal: boolean;
  setOpenAddToFunderListModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export function BotMessageButtons(props: BotMessageButtonsProps) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexFlow: "row",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0.5rem 0",
        }}
      >
        <Box>
          {/* <StyledButton>
            <ReplayOutlined
              sx={{
                marginRight: "0.5rem",
                transform: "scale(1.4) rotate(-60deg)",
              }}
            />
            <Typography>Redo</Typography>
          </StyledButton> */}
          {props.lazoChatConversation?.hasChart && (
            <StyledButton onClick={() => props.explainClick()}>
              <EditNoteOutlined
                sx={{
                  marginRight: "0.5rem",
                  transform: "scale(1.4)",
                }}
              />
              <Typography>Explain</Typography>
            </StyledButton>
          )}
          {!props.lazoChatConversation?.hasChart && props.writeApproachEmailClick != undefined && (
            <LazoTooltip title="Write me an approach email">
              <StyledButton onClick={props?.writeApproachEmailClick!}>
                <img src={MailSVG.src} style={{ marginRight: "0.3438rem" }} alt="mail-icon" />
                <Typography>Intro Email</Typography>
              </StyledButton>
            </LazoTooltip>
          )}
          {!props.lazoChatConversation?.hasChart && props.writeFollowUpEmailClick != undefined && (
            <LazoTooltip title="Write me a follow up email">
              <StyledButton onClick={props?.writeFollowUpEmailClick!}>
                <EditNoteOutlined
                  sx={{
                    marginRight: "0.5rem",
                    transform: "scale(1.4)",
                  }}
                />
                <Typography>Follow Up Email</Typography>
              </StyledButton>
            </LazoTooltip>
          )}
          {props.isExportable && (
            <>
              <AddInvestorToFunderListModal
                lazoChatConversation={props.lazoChatConversation}
                open={props.openAddToFunderListModal}
                setOpen={props.setOpenAddToFunderListModal}
                lazoChatMessage={props.messageEntity}
              />
            </>
          )}
        </Box>
        {/*
        <Box
          sx={{
            display: "flex",
            flexFlow: "row",
            gap: "0.7rem",
            "& .MuiSvgIcon-root": {
              color: Colors.STONE_GRAY,
              transform: "scale(1.3)",
              ":hover": {
                color: Colors.LAZO_PURPLE,
                cursor: "pointer",
              },
            },
          }}
        >
          <ThumbUpOutlined />
          <ThumbDownOutlined />
        </Box>
*/}
      </Box>
    </>
  );
}

export default ChatMessageContainer;
